exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{height:100%}body{font-family:Helvetica,sans-serif;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}header{-ms-flex:0 0 auto;flex:0 0 auto}#am-main-content{-ms-flex:1 0 auto;flex:1 0 auto}footer{-ms-flex:0 0 auto;flex:0 0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/App.vue
// module id = 127
// module chunks = 0